import { render, staticRenderFns } from "./OnlineExhibitionTable.vue?vue&type=template&id=39f8420f&scoped=true"
import script from "./OnlineExhibitionTable.vue?vue&type=script&lang=js"
export * from "./OnlineExhibitionTable.vue?vue&type=script&lang=js"
import style0 from "./OnlineExhibitionTable.vue?vue&type=style&index=0&id=39f8420f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f8420f",
  null
  
)

export default component.exports